// extracted by mini-css-extract-plugin
export default {"content":"Prices_content__BkF2B","planOption":"Prices_planOption__Akgvx"};